import * as React from "react";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpArrayMultilineString } from "../../../gvc/testNewForm/CpArrayMultilineString";
import { Divider } from "antd";
import { CpLabelDirtyIndicator } from "../../../gvc/testNewForm/CpLabelDirtyIndicator";
import { Only } from "../only";

interface Props {
  index: number;
}
export const WorkloadContainerRuntime: React.FC<Props> = React.memo(({ index: index }) => {
  return (
    <>
      <Divider orientation={`left`} orientationMargin={0}>
        Runtime Configuration
      </Divider>
      <CpFormItem>
        <CpLabel name={`containers.${index}.workingDir`}>
          Working Directory
          <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
            <CpLabelDirtyIndicator name={`containers.${index}.workingDir`} />
          </Only>
        </CpLabel>
        <CpInput name={`containers.${index}.workingDir`} style={{ width: 600 }} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`containers.${index}.command`}>
          Command
          <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
            <CpLabelDirtyIndicator name={`containers.${index}.command`} />
          </Only>
        </CpLabel>
        <CpInput name={`containers.${index}.command`} style={{ width: 600 }} />
      </CpFormItem>
      <div style={{ maxWidth: 600 }}>
        <CpArrayMultilineString
          label="Args"
          name={`containers.${index}.args`}
          dirtyIndicator={{
            isEnabled: true,
            only: {
              name: "meta.isCreate",
              checkFn: (v) => v === false,
            },
          }}
        />
      </div>
    </>
  );
});
